module.exports = __webpack_public_path__ + "img/aiads.3a4b2607.png";